import styled, { keyframes } from 'styled-components';

import { Row } from 'enable-ui';

export const GeneralContainer = styled.div`
  max-width: 800px;
`;

const slideDown = keyframes`
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const AnimatedRow = styled(Row)`
  animation: ${slideDown} 0.3s ease-out;
`;
